// src/components/Projects/Projects.js
// import React from 'react';
// import './Projects.css';

// const Projects = () => {
//   const projects = [
//     {
//       title: 'Customer Relationship Management (CRM)',
//       description: 'A comprehensive application that tracks work, leads, and progress with beautiful charts.',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=CRM',
//       appStore: '#',
//       playStore: '#'
//     },
//     {
//       title: 'E-Commerce App',
//       description: 'Feature-rich shopping application with product catalog, cart, payment integration, and order tracking.',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=E-Commerce',
//       appStore: '#',
//       playStore: '#'
//     },
//     {
//       title: 'Learning Managemnt System (LMS)',
//       description: 'An interactive learning companion that suggests courses provide learning material, and quiz .',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=LMS',
//       appStore: '#',
//       playStore: '#'
//     },
//     {
//       title: 'Social Media App',
//       description: 'A modern social networking platform with real-time messaging, media sharing, and community features.',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=Social+App',
//       appStore: '#',
//       playStore: '#'
//     },
//     {
//       title: 'Finance Manager',
//       description: 'Personal finance application for budgeting, expense tracking, and financial goal setting.',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=Finance+App',
//       appStore: '#',
//       playStore: '#'
//     },
//     {
//       title: 'Health & Wellness App',
//       description: 'Comprehensive wellness application with meditation guides, sleep tracking, and mental health resources.',
//       image: 'https://placehold.co/600x400/6C63FF/FFFFFF?text=Wellness+App',
//       appStore: '#',
//       playStore: '#'
//     }
//   ];

//   return (
//     <section id="projects" className="projects">
//       <div className="container">
//         <h2 className="section-title">My Projects</h2>
//         <div className="projects-container">
//           {projects.map((project, index) => (
//             <div key={index} className="project-card">
//               <div className="project-image">
//                 <img src={project.image} alt={project.title} />
//                 <div className="project-overlay">
//                   <div className="project-links">
//                     <a href={project.appStore} className="project-link">
//                       <i className="fab fa-apple"></i>
//                     </a>
//                     <a href={project.playStore} className="project-link">
//                       <i className="fab fa-google-play"></i>
//                     </a>
//                   </div>
//                 </div>
//               </div>
//               <div className="project-info">
//                 <h3>{project.title}</h3>
//                 <p>{project.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Projects;

// src/components/Projects/Projects.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Projects.css';
import { motion, AnimatePresence } from 'framer-motion';

const Projects = () => {
  const [hoveredProject, setHoveredProject] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const projects = [
     {
      id: 1,
      title: 'Vidya Global School App',
      description: 'A full-featured ERP based LMS application to manage students records, result, attendance, syllabus, Gallery, Announcements, Messaging.',
      image: '/images/VGSPreview.png',
      screenshots: [
        '/images/VGS1.png',
        '/images/VGS2.png',
        '/images/VGS3.png',
         '/images/VGS4.png',
        '/images/VGS5.png',
        '/images/VGS6.png',

      ],
      techStack: ['React Native', 'TypeScript', 'Redux', 'Node.js', 'MongoDB'],
      platforms: {
        playStore: 'https://play.google.com/store/apps/details?id=com.sits.vgs',
        appStore: 'https://apps.apple.com/in/app/vgs/id1616140930',
        apk: '',
        website: '',
      },
      features: [
        'Student Results',
        'Attendance',
        'Notice and Announcement',
        'Real-time Messaging'
      ]
    },
    {
      id: 2,
      title: 'SwiftCRM – CRM App',
      description: 'A full-featured CRM application to manage leads, deals, pipelines, tasks, and analytics with modern UI/UX.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      screenshots: [
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
      ],
      techStack: ['React Native', 'TypeScript', 'Redux', 'Node.js', 'MongoDB'],
      platforms: {
        playStore: '',
        appStore: '',
        apk: '/apk/SwiftCRM.apk',
        website: '',
      },
      features: [
        'Lead & Deal Management',
        'Real-time Analytics',
        'Team Collaboration',
        'Custom Workflows'
      ]
    },
     {
      id: 3,
      title: 'Lurnexa App',
      description:  'A comprehensive Learning Management System with courses, quizzes, assignments, progress tracking, and certification - similar to Udemy.',
      image: '/images/LurnexaLMSPreview.png',
      screenshots: [
        'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
      ],
      techStack: ['React Native', 'JavaScript', 'Redux', 'Node.js', 'MongoDB',],
      platforms: {
        playStore: '',
        appStore: '',
        apk: '/apk/LurnexaLMS.apk',
        website: '',
      },
      features: [
    'Interactive Course Catalog',
    'Quizzes & Assessments with Instant Grading',
    'Assignment Submission & Automated Evaluation',
    'Progress Tracking & Performance Analytics',
    'Certificate Generation upon Course Completion',
    'Discussion Forums & Peer-to-Peer Learning',
    'Download Courses for Offline Access',
    'Instructor Dashboard with Course Analytics',
    'Payment Gateway for Premium Content',
    'Push Notifications for Deadlines & Updates',
    'Bookmark & Save for Later Feature',
    'Live Class Integration',
  ],
    },
    {
      id: 4,
      title: 'E-Commerce Mobile App',
      description: 'A scalable e-commerce app with cart, checkout, payment gateway, order tracking, and admin dashboard.',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      screenshots: [
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
        'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80'
      ],
      techStack: ['React Native', 'Firebase', 'Stripe', 'Redux Toolkit'],
      platforms: {
       playStore: 'https://play.google.com/store/apps/details?id=com.way4mall',
        appStore: '',
        apk: '',
        website: '',
      },
      features: [
        'Secure Payments',
        'Order Tracking',
        'Wishlist & Favorites',
        'Push Notifications'
      ]
    },
   {
  id: 5,
  title: 'Way4Recharge – Utility & Recharge App',
  description:
    'Recharge and utility payment app supporting mobile, DTH, and bill payments with real-time transaction updates.',
  image: '/images/Way4RechargePreview.png',
  screenshots: [
    '/images/Way4Recharge1.png',
    '/images/Way4Recharge2.png',
    '/images/Way4Recharge3.png'
  ],
  techStack: ['React Native', 'REST APIs', 'Secure Payments'],
  platforms: {
    playStore: 'https://play.google.com/store/apps/details?id=com.way4recharge',
    appStore: '',
    apk: '',
    website: ''
  },
  features: [
    'Mobile & DTH Recharge',
    'Bill Payments',
    'Real-time Transaction Status',
    'Secure Payment Flow'
  ]
},
{
  id: 6,
  title: 'SBSC – ERP & Institutional App',
  description:
    'Enterprise ERP application for managing academic workflows, administration, and institutional operations.',
  image:    '/Images/SBSCLogo.png',
  screenshots: [
    '/Images/SBSC1.webp',
    '/images/SBSC2.png',
    '/images/SBSC3.png'
  ],
  techStack: ['React Native', 'TypeScript', 'Secure APIs'],
  platforms: {
    playStore:
      'https://play.google.com/store/apps/details?id=com.sits.sitsliveerpsbsc',
    appStore:
      'https://apps.apple.com/in/app/sbsc/id6453025645',
    apk: '',
    website: ''
  },
  features: [
    'Role-Based Access',
    'Academic Management',
    'Admin & Staff Dashboards'
  ]
},
{
  id: 7,
  title: 'Rayhope Global – e-Commerce App',
  description:
    'Rayhope Global is a cutting-edge e-commerce application designed to bring the best of online shopping to your fingertips.',
  image: '/Images/RayhopePreview.png',
  screenshots: [
    '/Images/Rayhope1.png',
    '/Images/Rayhope2.png'
  ],
  techStack: ['React Native', 'JavaScript', 'REST APIs'],
  platforms: {
    playStore:
      'https://play.google.com/store/apps/details?id=com.rayhope',
    appStore: '',
    apk: '',
    website: ''
  },
  features: [
    'Secure Payments',
        'Order Tracking',
        'Wishlist & Favorites',
        'Push Notifications'
  ]
},
{
  id: 8,
  title: 'Glowoman – Salon Booking Platform',
  description:
    'Service booking platform enabling users to browse services, book appointments, and manage schedules.',
  image: '/Images/GlowomanWeb.png',
  screenshots: [  '/Images/GlowomanWeb.png'],
  techStack: ['React.js', 'REST APIs'],
  platforms: {
    website: 'https://www.glowoman.in'
  },
  features: ['Service Booking', 'Responsive UI', 'User Management']
},
{
  id: 9,
  title: 'Beds & Divans – E-commerce Website',
  description:
    'Furniture e-commerce website with product listings, filtering, and SEO-optimized UI.',
  image: '/Images/BedsDivanPreview.png',
  screenshots: ['/images/BedsDivans1.png'],
  techStack: ['React.js', 'SEO', 'Responsive Design'],
  platforms: {
    website: 'https://bedsdivans.co.uk'
  },
  features: ['Product Listings', 'Category Filtering', 'SEO Optimization']
},
{
  id: 10,
  title: 'Daylyy – Social media Platform',
  description:
    'Social media used to be where you shared your day.',
  image: '/Images/DayllyPreview.png',
  screenshots: ['/Images/DayllyPreview.png',],
  techStack: ['React.js', 'REST APIs'],
  platforms: {
    website: 'https://www.daylyy.com'
  },
  features: ['Service Showcase', 'Responsive UI']
},
{
  id: 11,
  title: 'Alba Cars – Automotive Website',
  description:
    'Corporate website for an automotive business with vehicle listings and lead generation.',
  image: '/Images/AlbaCars1.png',
  screenshots: ['/Images/AlbaCars1.png'],
  techStack: ['React.js', 'Responsive Design'],
  platforms: {
    website: 'https://albacars.ae'
  },
  features: ['Vehicle Listings', 'Lead Generation']
},
// {
//   id: 12,
//   title: 'EbaTech – Admin Management System',
//   description:
//     'Admin dashboard for managing business services, configurations, and operations.',
//   image: '/images/EbaTechPreview.png',
//   screenshots: ['/images/EbaTech1.png'],
//   techStack: ['React.js', 'Material UI', 'REST APIs'],
//   platforms: {
//     website: 'https://ebatechnology.netlify.app'
//   },
//   features: ['Admin Dashboard', 'Config Management']
// },
// {
//   id: 13,
//   title: 'Victor India – Business Utility App',
//   description:
//     'Business utility mobile app providing services, content management, and customer interaction features.',
//   image: '/images/VictorPreview.png',
//   screenshots: [
//     '/images/Victor1.png',
//     '/images/Victor2.png'
//   ],
//   techStack: ['React Native', 'JavaScript', 'REST APIs'],
//   platforms: {
//     playStore:
//       'https://play.google.com/store/apps/details?id=com.victorindia',
//     appStore: '',
//     apk: '',
//     website: ''
//   },
//   features: [
//     'Business Services',
//     'Content Management',
//     'Customer Engagement'
//   ]
// },


  ];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleViewProject = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-subtitle">My Work</h2>
          <h1 className="section-title">Featured Projects</h1>
          <p className="section-description">
            Here are some of my recent projects that showcase my skills and expertise in modern web and mobile development.
          </p>
        </motion.div>

        <div className="projects-grid">
          <AnimatePresence>
            {projects.map((project, index) => (
              <motion.div
                key={project.id}
                className="project-card-wrapper"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                onMouseEnter={() => setHoveredProject(project.id)}
                onMouseLeave={() => setHoveredProject(null)}
              >
                <div className="project-card">
                  <div className="project-image-container">
                    <img 
                      src={project.image} 
                      alt={project.title}
                      className="project-image"
                    />
                    <div className="project-badge">
                      <span className="badge-text">{project.techStack[0]}</span>
                    </div>
                  </div>
                  
                  <div className="project-content">
                    <h3 className="project-title">{project.title}</h3>
                    <p className="project-description">{project.description}</p>
                    
                    <div className="tech-stack">
                      {project.techStack.slice(0, 3).map((tech, i) => (
                        <span key={i} className="tech-tag">{tech}</span>
                      ))}
                      {project.techStack.length > 3 && (
                        <span className="tech-tag">+{project.techStack.length - 3}</span>
                      )}
                    </div>
                  </div>

                  {/* Hover Overlay */}
                  <div className={`project-overlay ${hoveredProject === project.id ? 'active' : ''}`}>
                    <div className="overlay-content">
                      <h3 className="overlay-title">{project.title}</h3>
                      <div className="overlay-tech">
                        {project.techStack.slice(0, 4).map((tech, i) => (
                          <span key={i} className="overlay-tech-tag">{tech}</span>
                        ))}
                      </div>
                      <motion.button
                        className="view-project-btn"
                        onClick={() => handleViewProject(project.id)}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                      >
                        <span>View Details</span>
                        <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </motion.button>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Projects;
